(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
